<template>
  <div class="tt-header">
    <!-- Left: Coin selection -->
    <div class="symbol-price" @click="toggleSymbolDropdown" ref="symbolEl">
      <img class="icon" :src="iconUrl(activeBase)" :alt="activeBase" />
      <div class="info">
        <div class="sym">{{ activeBase }}/USDT</div>
        <div class="price" :style="{ color: priceColor }">{{ fmt(currentPrice) }}</div>
      </div>
      <svg class="chev" viewBox="0 0 20 20" width="16" height="16">
        <path fill="currentColor" d="M5.5 7l4.5 4.5L14.5 7z"/>
      </svg>
    </div>

<!-- Interval button -->
<div class="interval-wrap" ref="intervalEl">
  <button class="interval-btn" @click="toggleIntervals">
    {{ intervalLabel }}
    <svg class="chev" viewBox="0 0 20 20" width="14" height="14">
      <path fill="currentColor" d="M5.5 7l4.5 4.5L14.5 7z"/>
    </svg>
  </button>

  <!-- Desktop Dropdown -->
  <transition name="fade">
    <div v-if="intervalsDropdown && !isMobile" class="dropdown styled" ref="intervalDrop">
      <div
        v-for="opt in allIntervals"
        :key="opt"
        class="row"
        :class="{ sel: opt === props.interval }"
        @click="pickInterval(opt)"
      >
        <span class="row-icon">{{ intervalIcon(opt) }}</span>
        {{ opt }}
      </div>
    </div>
  </transition>
</div>

<!-- Mobile Bottom Sheet -->
<transition name="slide-up">
  <div v-if="intervalsDropdown && isMobile" class="bottom-sheet" @click.self="closeSheet">
    <div class="sheet-content" ref="sheet" 
         @touchstart="onTouchStart" 
         @touchmove="onTouchMove" 
         @touchend="onTouchEnd">

      <!-- Drag handle -->
      <div class="sheet-handle"></div>

      <!-- Header -->
      <div class="sheet-header">
  <h3> {{ $t('turbo.Chart Interval') }}</h3>
</div>

<!-- Options scrollable -->
<div class="sheet-options">
  <div
    v-for="opt in allIntervals"
    :key="opt"
    class="row"
    :class="{ sel: opt === props.interval }"
    @click="pickInterval(opt)"
  >
    <span class="row-icon">{{ intervalIcon(opt) }}</span>
    {{ opt }}
  </div>
</div>

    </div>
  </div>
</transition>




    <!-- Help -->
    <button class="help" @click="showHelp=true"><span>?</span></button>

<!-- PC Dropdown -->
<transition name="fade">
  <div v-if="symbolDropdown && !isMobile" class="tt-dropdown" ref="symbolDrop">

    <!-- Tabs -->
    <div class="tt-tabs">
      <button :class="{ active: activeTab==='favorites' }" @click="activeTab='favorites'">  {{ $t('turbo.My Favorites') }}</button>
      <button :class="{ active: activeTab==='all' }" @click="activeTab='all'">  {{ $t('turbo.All Coins') }}</button>
    </div>

    <!-- Search -->
    <div class="tt-search-box">
      <input v-model="searchQuery" type="text" placeholder="Search coin..." />
    </div>

    <!-- Headers -->
    <div class="tt-list-header">
      <span> {{ $t('turbo.Coin') }}</span>
      <span> {{ $t('turbo.Last Price') }} <button @click="toggleSort('price')">⬆⬇</button></span>
      <span> {{ $t('turbo.Change') }}% <button @click="toggleSort('change')">⬆⬇</button></span>
    </div>

    <!-- Coin List -->
    <div class="tt-coin-list">
      <div
        v-for="opt in filteredCoins"
        :key="opt.symbol"
        class="tt-coin-row"
        :class="{ sel: opt.symbol === props.symbol }"
        @click="pickSymbol(opt.symbol)"
      >
        <!-- Coin -->
        <div class="tt-coin-left">
          <img class="tt-coin-icon" :src="iconUrl(baseFromSymbol(opt.symbol))" />
          <span>{{ prettySymbol(opt.symbol) }}</span>
          <button class="tt-fav-btn" @click.stop="toggleFavorite(opt.symbol)">
            {{ favorites.includes(opt.symbol) ? '★' : '☆' }}
          </button>
        </div>
        <!-- Last Price -->
        <div style="text-align:right;">
          {{ fmt(opt.price) }}
        </div>
        <!-- Change % -->
        <div style="text-align:right;" :style="{ color: opt.change >= 0 ? '#22c55e' : '#ef4444' }">
          {{ opt.change.toFixed(2) }}%
        </div>
      </div>
    </div>
  </div>
</transition>


<!-- Coin Sheet -->
<transition name="slide-up">
  <div v-if="symbolDropdown && isMobile" class="tt-sheet" @click.self="closeSheet">
    <div class="tt-sheet-content" ref="sheet">
      
      <!-- Drag handle -->
      <div class="tt-sheet-handle"
           @touchstart="onTouchStart"
           @touchmove="onTouchMove"
           @touchend="onTouchEnd"></div>

   

      <!-- Tabs -->
      <div class="tt-tabs" ref="sheet"   @touchstart="onTouchStart"
           @touchmove="onTouchMove"
           @touchend="onTouchEnd" >
        <button :class="{ active: activeTab==='favorites' }" @click="activeTab='favorites'"> {{ $t('turbo.My Favorites') }}</button>
        <button :class="{ active: activeTab==='all' }" @click="activeTab='all'"> {{ $t('turbo.All Coins') }}</button>
      </div>

      <!-- Search -->
      <div class="tt-search-box">
        <input v-model="searchQuery" type="text" placeholder="Search coin..." />
      </div>

      <!-- Headers -->
      <div class="tt-list-header">
        <span> {{ $t('turbo.Coin') }}</span>
        <span> {{ $t('turbo.Last Price') }} <button @click="toggleSort('price')">⬆⬇</button></span>
        <span>  {{ $t('turbo.Change') }}% <button @click="toggleSort('change')">⬆⬇</button></span>
      </div>

      <!-- Coin List -->
      <div class="tt-coin-list">
        <div
          v-for="opt in filteredCoins"
          :key="opt.symbol"
          class="tt-coin-row"
          :class="{ sel: opt.symbol === props.symbol }"
          @click="pickSymbol(opt.symbol)"
        >
          <div class="tt-coin-left">
            <img class="tt-coin-icon" :src="iconUrl(baseFromSymbol(opt.symbol))" />
            <span>{{ prettySymbol(opt.symbol) }}</span>
            <button class="tt-fav-btn" @click.stop="toggleFavorite(opt.symbol)">
              {{ favorites.includes(opt.symbol) ? '★' : '☆' }}
            </button>
          </div>
          <div style="text-align:right;">
            {{ fmt(opt.price) }}
          </div>
          <div style="text-align:right;" :style="{ color: opt.change >= 0 ? '#22c55e' : '#ef4444' }">
            {{ opt.change.toFixed(2) }}%
          </div>
        </div>
      </div>

    </div>
  </div>
</transition>




  
  </div>
</template>

<script setup>
import { ref, computed, onMounted, onUnmounted, watch } from 'vue'

const props = defineProps({
  symbol: { type: String, required: true },
  symbolOptions: { type: Array, default: () => ['BTCUSDT','ETHUSDT','BNBUSDT'] },
  interval: { type: String, default: 'tick' }
})
const emit = defineEmits(['update:symbol', 'update:interval'])

const currentPrice = ref(null)
const prevPrice = ref(null)
let ws = null

const symbolDropdown = ref(false)
const intervalsDropdown = ref(false)
const showHelp = ref(false)

const symbolEl = ref(null)
const symbolDrop = ref(null)
const intervalEl = ref(null)
const intervalDrop = ref(null)

const allIntervals = [
  'tick',
  '1m','3m','5m','15m','30m',
  '1h','2h','4h','6h','8h','12h'
]

const activeTab = ref('all')
const searchQuery = ref('')
const favorites = ref(JSON.parse(localStorage.getItem('favorites') || '[]'))
const sortKey = ref(null)
const sortDir = ref(1) // 1 asc, -1 desc

// coinOptions içeriğini fiyat ve change % ile genişlet
const coins = ref(props.symbolOptions.map(sym => ({
  symbol: sym,
  price: 0,
  change: 0
})))

function toggleFavorite(sym) {
  if (favorites.value.includes(sym)) {
    favorites.value = favorites.value.filter(s => s !== sym)
  } else {
    favorites.value.push(sym)
  }
  localStorage.setItem('favorites', JSON.stringify(favorites.value))
}

function toggleSort(key) {
  if (sortKey.value === key) {
    sortDir.value *= -1
  } else {
    sortKey.value = key
    sortDir.value = 1
  }
}

const filteredCoins = computed(() => {
  let list = coins.value

  // tab
  if (activeTab.value === 'favorites') {
    list = list.filter(c => favorites.value.includes(c.symbol))
  }

  // search
  if (searchQuery.value) {
    list = list.filter(c =>
      c.symbol.toLowerCase().includes(searchQuery.value.toLowerCase())
    )
  }

  // sort
  if (sortKey.value) {
    list = [...list].sort((a, b) => (a[sortKey.value] - b[sortKey.value]) * sortDir.value)
  }

  return list
})

const activeBase = computed(() => baseFromSymbol(props.symbol))
const intervalLabel = computed(() => props.interval)

const priceColor = computed(() => {
  if (currentPrice.value == null || prevPrice.value == null) return '#cbd5e1'
  if (currentPrice.value > prevPrice.value) return '#22c55e'
  if (currentPrice.value < prevPrice.value) return '#ef4444'
  return '#cbd5e1'
})



function baseFromSymbol(sym) {
  return sym.replace(/USDT$/,'')
}
function prettySymbol(sym) {
  return `${baseFromSymbol(sym)}/USDT`
}
function iconUrl(base) {
  const url1 = `https://cdn.jsdelivr.net/gh/vadimmalykhin/binance-icons/crypto/${base.toLowerCase()}.svg`
  const url2 = `https://alternative-cdn.com/icons/${base.toLowerCase()}.png`
  return url1  // fallback durumunu da yönetebiliriz ancak Vue’da error olayına bağlamak daha sağlıklı olur.
}

function fmt(v) {
  if (v == null) return '—'
  return new Intl.NumberFormat('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 6 }).format(v)
}
function wsUrl(sym) {
  return `wss://stream.binance.com:9443/ws/${sym.toLowerCase()}@trade`
}



function connect() {
  if (ws) ws.close()
  ws = new WebSocket(wsUrl(props.symbol))
  ws.onmessage = (ev) => {
    const m = JSON.parse(ev.data)
    const price = parseFloat(m.p)
    if (currentPrice.value == null) {
      prevPrice.value = price
      currentPrice.value = price
    } else {
      prevPrice.value = currentPrice.value
      currentPrice.value = price
    }
  }
}
let wsAll = null

function connectAllTickers() {
  if (wsAll) wsAll.close()
  wsAll = new WebSocket("wss://stream.binance.com:9443/ws/!miniTicker@arr")

wsAll.onmessage = (ev) => {
  const arr = JSON.parse(ev.data)
  arr.forEach(t => {
    const coin = coins.value.find(c => c.symbol === t.s)
    if (coin) {
      const last = parseFloat(t.c)
      const open = parseFloat(t.o)
      coin.price = last
      coin.change = ((last - open) / open) * 100   // ✅ % değişim hesapla
    }
  })
}

}
watch(() => props.symbol, () => {
  currentPrice.value = null
  prevPrice.value = null
  connect()
})

const isMobile = ref(window.innerWidth <= 768)
const sheet = ref(null)
let startY = 0
let sheetTranslateY = 0
let currentY = 0
let isDragging = false

function closeSheet() {
  symbolDropdown.value = false
  intervalsDropdown.value = false
}


function onTouchStart(e) {
  startY = e.touches[0].clientY
  sheetTranslateY = 0
}

function onTouchMove(e) {
  if (!sheet.value) return
  const diff = e.touches[0].clientY - startY

  // sadece aşağıya kaydırma
  if (diff > 0) {
    sheetTranslateY = diff
    sheet.value.style.transform = `translateY(${diff}px)`
  }
}

function onTouchEnd() {
  if (!sheet.value) return

  if (sheetTranslateY > 100) {
    // doğrudan kapat
    closeSheet()
  }
  // aksi durumda hiçbir şey yapma, sheet yerinde kalsın
}



onMounted(() => {
  window.addEventListener("resize", () => {
    isMobile.value = window.innerWidth <= 768
  })
})

onMounted(() => {
  connect()
  connectAllTickers()   // ✅ tüm coinleri güncelle
  document.addEventListener('click', docClick, true)
})
onUnmounted(() => {
  if (ws) ws.close()
  document.removeEventListener('click', docClick, true)
})

function toggleSymbolDropdown() {
  symbolDropdown.value = !symbolDropdown.value
  intervalsDropdown.value = false
}
function toggleIntervals() {
  intervalsDropdown.value = !intervalsDropdown.value
  symbolDropdown.value = false
}
function pickSymbol(sym) {
  symbolDropdown.value = false
  if (sym !== props.symbol) emit('update:symbol', sym)
}
function intervalIcon(opt) {
  return opt === 'tick' ? '✔️' : '🕯️'
}

function pickInterval(val) {
  intervalsDropdown.value = false
  if (val !== props.interval) {
    emit('update:interval', val) // Chart'a yeni interval gönder
  }
}
function docClick(e) {
  // Coin sheet açıksa
  if (symbolDropdown.value && isMobile.value) {
    // Eğer tıklama sheet içerisine geldiyse kapatma
    if (sheet.value?.contains(e.target)) return
    symbolDropdown.value = false
  }

  // Interval sheet
  if (intervalsDropdown.value && isMobile.value) {
    if (sheet.value?.contains(e.target)) return
    intervalsDropdown.value = false
  }

  // PC dropdown (sembol seçim)
  if (symbolDropdown.value && !isMobile.value) {
    if (symbolEl.value?.contains(e.target) || symbolDrop.value?.contains(e.target)) return
    symbolDropdown.value = false
  }

  // PC dropdown (interval)
  if (intervalsDropdown.value && !isMobile.value) {
    if (intervalEl.value?.contains(e.target) || intervalDrop.value?.contains(e.target)) return
    intervalsDropdown.value = false
  }
}

</script>


<style scoped>
text {
    font-family: "Montserrat", Arial, "Segoe UI", Helvetica, sans-serif;
    font-size: 14px;
    font-variant-numeric: lining-nums tabular-nums;
    font-weight: 600;
    letter-spacing: -.02em;
    line-height: 18px;
    margin-bottom: 0;
    margin-top: 0;
}

.tt-header {
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 10px 12px;
  background: var(--background);
  border-radius: 7px;
  margin-bottom: 10px;
  position: relative;
  z-index: 1;
}

 
/* Coin selection */
.symbol-price {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 6px 10px;
  border-radius: 5px;
  background: var(--background2);
  cursor: pointer;
  position: relative;
  z-index: 1;

  font-family: "Montserrat", Arial, "Segoe UI", Helvetica, sans-serif;
    font-size: 14px;
    font-variant-numeric: lining-nums tabular-nums;
    font-weight: 600;
    letter-spacing: -.02em;
    line-height: 18px;
}

 

.icon { width: 22px; height: 22px; border-radius: 50%; }
.info { display: flex; flex-direction: column; line-height: 1.1; }
.sym { font-size: 12px; color: #fbbf24; }
.price { font-size: 14px; font-weight: 600; }
.chev { color: #fbbf24; }

/* Interval button */
.interval-wrap { margin-left: auto; position: relative; }
.interval-btn {
  display: flex; align-items: center; gap: 4px;
  background:  var(--background2);
  border-radius: 5px;
  padding: 6px 10px;
  border: none;
  cursor: pointer;
  color: #e2e8f0;
  position: relative;
  z-index: 1;
  font-family: "Montserrat", Arial, "Segoe UI", Helvetica, sans-serif;
    font-size: 14px;
    font-variant-numeric: lining-nums tabular-nums;
    font-weight: 600;
    letter-spacing: -.02em;
    line-height: 18px;
}

 

/* Desktop/Mobile toggle */
.desktop-only { display: block; }
.mobile-only { display: none; }
@media (max-width: 768px) {
  .desktop-only { display: none; }
  .mobile-only { display: block; }
}

/* Bottom sheet */
.bottom-sheet {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0,0,0,0.5);
  z-index: 9999; /* ✅ her şeyin üstüne çık */
  display: flex;
  justify-content: center;
  align-items: flex-end;
    
}

.sheet-content {
  background: var(--background, #0b1220);
  border-top-left-radius: 16px;
  border-top-right-radius: 16px;
  width: 100%;
  max-height: 60%;
  display: flex;           /* ✅ dikey düzen */
  flex-direction: column;  /* ✅ header sabit, options scroll */
  position: relative;
  z-index: 1;
}
.sheet-content {
  -webkit-overflow-scrolling: touch; /* ✅ iOS scroll momentum */
}



.sheet-handle {
  width: 40px;
  height: 5px;
  background: #666;
  border-radius: 3px;
  margin: 8px auto;
}

/* Header */
.sheet-header {
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  padding: 8px 0 12px;
}
.sheet-header h3 {
  margin: 0;
  font-family: "Montserrat", Arial, "Segoe UI", Helvetica, sans-serif;
    font-size: 14px;
    font-variant-numeric: lining-nums tabular-nums;
    font-weight: 600;
    letter-spacing: -.02em;
    line-height: 18px;
  color: #e2e8f0;

}
.close-btn {
  position: absolute;
  right: 0;
  top: 0;
  background: transparent;
  border: none;
  font-size: 18px;
  color: #aaa;
  cursor: pointer;
}

/* Slide animation */
.slide-up-enter-active, .slide-up-leave-active {
  transition: all 0.3s ease;
}
.slide-up-enter-from {
  opacity: 0;
  transform: translateY(100%);
}
.slide-up-enter-to {
  opacity: 1;
  transform: translateY(0);
}
.slide-up-leave-from {
  opacity: 1;
  transform: translateY(0);
}
.slide-up-leave-to {
  opacity: 0;
  transform: translateY(100%);
}


.sheet-options {
  flex: 1;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  padding: 0 16px 16px;

  display: grid;                          /* ✅ grid sistemi */
  grid-template-columns: repeat(auto-fill, minmax(80px, 1fr));
  gap: 10px;   
  padding-bottom: 150px;                   
}

.row {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 12px;
  border-radius: 7px;
  font-weight: bold;
  text-align: center;
  cursor: pointer;
  color: #fff;
  background: var(--background2);
  position: relative;
  z-index: 1;
}
.row-icon {
  width: 18px;
  text-align: center;
  display: none;
}


/* Dropdown base */
/* Dropdown grid */
.dropdown.styled {
  position: absolute;
  top: calc(100% + 22px);
  right: -55px;
  display: grid; 
  grid-template-columns: repeat(4, 1fr); /* ✅ 4 sütun */
  gap: 8px;                               /* ✅ aralıklar */
  padding: 12px;                          /* ✅ iç boşluk */
  border-radius: 5px;
  background: var(--background, #0b1220);
  box-shadow: 0px 6px 10px rgba(0, 0, 0, 0.15);
  z-index: 10;
}

/* Dropdown içindeki seçenekler */
.dropdown.styled .row {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 10px;
  border-radius: 6px;
  font-weight: bold;
  text-align: center;
  cursor: pointer;
  color: #fff;
 
  position: relative;
  z-index: 1;
}

 

.help {
        display: flex
;
    align-items: center;
    gap: 4px;
  background:  var(--background2);
    border-radius: 5px;
    padding: 6px 10px;
    border: none;
    cursor: pointer;
    color: #e2e8f0;
    position: relative;
    z-index: 1;

}

 
.row {
  padding: 8px 12px;
  cursor: pointer;
  color: #fff;
  width: 100%;
  text-align: center;
  font-weight: bold;
      background: var(--background2);
    border-radius: 7px;
    margin-top: 10px;
    position: relative;
    z-index: 1;
}

 
.row.sel { 
  background: var(--buttonyellow); 
  border-radius: 7px;
  box-shadow: rgb(197, 106, 24) 0px -3px 0px 0px inset, rgb(255, 234, 47) 0px 2px 0px 0px inset;
  color: #000;

}



/* Tabs */
.tt-tabs {
  display: flex;
  border-bottom: 1px solid #1e293b;
  margin-bottom: 8px;
   
}
.tt-tabs button {
  flex: 1;
  padding: 8px;
  background: none;
  border: none;
  color: #fbbf24;
  font-weight: 600;
  cursor: pointer;
  font-family: "Montserrat", Arial, "Segoe UI", Helvetica, sans-serif;
    font-size: 14px;
    font-variant-numeric: lining-nums tabular-nums;
    font-weight: 600;
    letter-spacing: -.02em;
    line-height: 18px;
}
.tt-tabs button.active {
  color: #fff;
  border-bottom: 2px solid #fbbf24;
}

/* Search */
.tt-search-box {
  padding: 6px 5px;
}
.tt-search-box input {
  width: 100%;
  padding: 6px 10px;
  border-radius: 6px;
  border: 1px solid var(--outline);
  background: var(--search-bg);
  color: #fff;
}

/* Headers */

.tt-list-header {
  display: grid;
  grid-template-columns: 2fr 1fr 1fr; /* Coin geniş, fiyat ve % dar */
  font-size: 12px;
  font-weight: 600;
  color: #fbbf24;
  padding: 6px 0;
}
@media (max-width: 768px) {

 .tt-list-header {
  display: grid;
  grid-template-columns: 2fr 1fr 1fr; /* Coin geniş, fiyat ve % dar */
  font-size: 12px;
  font-weight: 600;
  color: #fbbf24;
  padding: 6px 10px;

  font-family: "Montserrat", Arial, "Segoe UI", Helvetica, sans-serif;
    font-size: 14px;
    font-variant-numeric: lining-nums tabular-nums;
    font-weight: 600;
    letter-spacing: -.02em;
    line-height: 18px;
}

}

.tt-list-header span {
  text-align: right;
}
.tt-list-header span:first-child {
  text-align: left;
}

/* Coin list */
.tt-coin-list {
  flex: 1;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch; /* iOS smooth scroll */
   
}

/* ✅ Sadece mobilde padding ekle */
@media (max-width: 768px) {
  .tt-coin-list {
    padding-left: 10px;
    padding-right: 10px;
    padding-bottom: 200px;
  }
}



.tt-coin-row {
  display: grid;
  grid-template-columns: 2fr 1fr 1fr;
  align-items: center;
  padding: 6px 0;
  cursor: pointer;
  color: #fbbf24;
  font-family: "Montserrat", Arial, "Segoe UI", Helvetica, sans-serif;
    font-size: 12px;
    font-variant-numeric: lining-nums tabular-nums;
     font-weight: bold;
}
.tt-coin-row.sel {
  background: var(--background2);
  border-radius: 6px;
 font-weight: bold;
 color: #fff;
}


/* Coin left */
.tt-coin-left {
  display: flex;
  align-items: center;
  gap: 6px;
  margin-left: 5px;
}
.tt-coin-icon {
  width: 20px;
  height: 20px;
}
.tt-fav-btn {
  margin-left: auto;
  background: none;
  border: none;
  cursor: pointer;
  color: gold;
  font-size: 14px;
}

.tt-dropdown {
  position: absolute;
  top: calc(100% + 6px);
  left: 0;
  width: 450px;
  max-height: 400px;
  /* overflow-y: auto;  ❌ kaldır */
  padding: 12px;
  border-radius: 8px;
  background: var(--background, #0b1220);
  box-shadow: 0px 6px 12px rgba(0,0,0,0.2);
  z-index: 2000;

  display: flex;         /* ✅ dikey düzen */
  flex-direction: column;
}

.tt-sheet {
  position: fixed;
  left: 0;
  right: 0;
  top: 0;      /* ✅ üstten başlasın */
  bottom: 0;   /* ✅ altta bitsin */
  background: rgba(0,0,0,0.5);
  z-index: 9999;
  display: flex;
  justify-content: center;
  align-items: flex-end;
}

.tt-sheet-content {
  width: 100vw;          /* ✅ ekran genişliği */
  max-width: 100vw;      /* sağ-sol taşma engel */
  border-top-left-radius: 16px;
  border-top-right-radius: 16px;
  background: var(--background, #0b1220);
  max-height: 80%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.tt-sheet-handle {
  width: 40px;
  height: 5px;
  background: #666;
  border-radius: 3px;
  margin: 10px auto; /* ✅ ortaya */
  cursor: pointer;   /* ✅ tıklanabilir */
}

</style>
